module.exports = __webpack_public_path__ + "img/P150T_weapon_148.35ec15fa.png";